import React from "react"
import { useTranslation } from "react-i18next"

import { Label, Textarea } from "@f2e/ui/components/base"

export const INVOCATION_INSTRUCTION_MAX_LENGTH = 2000

export interface InvocationInstructionFieldProps {
  id?: string
  label?: string
  placeholder: string
  value?: string
  onChange: (value: string) => void
  disabled?: boolean
  rows?: number
  maxLength?: number
}

export const InvocationInstructionField: React.FC<
  InvocationInstructionFieldProps
> = ({
  id,
  label,
  placeholder,
  value,
  onChange,
  disabled = false,
  rows = 2,
  maxLength = INVOCATION_INSTRUCTION_MAX_LENGTH,
}) => {
  const { t } = useTranslation()
  const currentValue = value ?? ""
  const resolvedLabel =
    label ??
    t("workspace.agent.basicForm.unifiedToolSelector.invocationInstruction")
  const isLimitReached = currentValue.length >= maxLength

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const nextValue = event.target.value.slice(0, maxLength)
    onChange(nextValue)
  }

  return (
    <div className="space-y-2 min-w-0">
      <Label htmlFor={id} className="text-sm font-medium">
        {resolvedLabel}
      </Label>
      <Textarea
        id={id}
        placeholder={placeholder}
        value={currentValue}
        maxLength={maxLength}
        onChange={handleChange}
        disabled={disabled}
        rows={rows}
        className="text-sm w-full max-w-full min-w-0 max-h-32 resize-none overflow-y-auto overflow-x-hidden break-all [overflow-wrap:anywhere] [field-sizing:fixed]"
      />
      <p className="text-xs text-muted-foreground">
        {t(
          "workspace.agent.basicForm.unifiedToolSelector.invocationInstructionHelp",
          { max: maxLength }
        )}
      </p>
      {isLimitReached && (
        <div className="text-xs text-red-600 dark:text-red-400">
          {t(
            "workspace.agent.basicForm.unifiedToolSelector.invocationInstructionLimitReached",
            { max: maxLength }
          )}
        </div>
      )}
    </div>
  )
}
